// extracted by mini-css-extract-plugin
module.exports = {"textPreLine":"FrequentlyAskedQuestion__textPreLine___2hKNj"};